import IknowCodec from 'app/config/types/Iknow';
import * as t from 'io-ts';
import Client from 'app/config/types/Client';
import DeployInfo from 'app/config/types/DeployInfo';
import Environment from 'app/config/types/Environment';
import Fluentd from 'app/config/types/Fluentd';
import Honeybadger from 'app/config/types/Honeybadger';
import OAuth from 'app/config/types/OAuth';
import PhraseApp from 'app/config/types/PhraseApp';
import Recaptcha from 'app/config/types/Recaptcha';
import Transcoding from 'app/config/types/Transcoding';
import ReamazeCodec from 'app/config/types/Reamaze';

const ClientConfigFiles = {
  deployInfo:      DeployInfo,
  honeybadger:     Honeybadger,
  fluentd:         Fluentd,
  phraseapp:       PhraseApp,
  oauth:           OAuth,
  transcoding:     Transcoding,
  environment:     Environment,
  client:          Client,
  recaptcha:       Recaptcha,
  iknow:           IknowCodec,
  reamaze:         ReamazeCodec,
};

export const ClientConfigs = t.exact(t.interface(ClientConfigFiles), 'ClientConfigs');

export const CLIENT_CONFIG_NAMES = Object.keys(ClientConfigFiles);

export type IClientConfigs = t.TypeOf<typeof ClientConfigs>;
